import * as Sentry from '@sentry/vue'
import store from '@/vuex/store'

const MESSAGE_TYPES = {
  ANNOTATIONS_UPDATED: 'annotationsUpdated',
}

/**
 * Extracts the first slide ID with annotation from the annotations data
 * Based on the order they appear in the array (first annotation = first slide to activate)
 * @param {Array} annotations - Array of annotation objects
 * @returns {string|null} First slide ID with annotation, or null
 */
function extractFirstAnnotatedSlideId(annotations) {
  if (!Array.isArray(annotations) || annotations.length === 0) {
    return null
  }

  // The first annotation in the array represents the first slide that should be activated
  const firstAnnotation = annotations[0]
  return firstAnnotation?.slideId?.toString() || null
}

/**
 * Handles annotation update events from the server
 * @param {Array} data - Annotation data from the server
 */
export function handleAnnotationUpdated(data) {
  try {
    // Validate data
    if (!Array.isArray(data) || data.length === 0) return

    // Check if the feature is enabled
    if (!store.getters['slideAnnotations/canUseSlideAnnotations']) return

    // Update annotations in store with the simplified format
    store.commit('slideAnnotations/SET_ANNOTATIONS', {
      annotations: data,
    }, { root: true })

    // Use the safe action that will check if presentation slides are ready
    // and retry if necessary
    store.dispatch('slideAnnotations/safelyHandleAnnotationSyncAction', null, { root: true })

    // Extract the first slide ID with annotation for presentation updates
    const firstAnnotatedSlideId = extractFirstAnnotatedSlideId(data)

    // Store the first annotated slide ID for use by presentation update handler
    if (firstAnnotatedSlideId) {
      store.dispatch('slideAnnotations/setFirstAnnotatedSlideId', firstAnnotatedSlideId, { root: true })
    }
  } catch (error) {
    Sentry.captureException(error)
  }
}

// Export handlers mapped to message types
const SlideAnnotationsWebsocketSubscriber = {
  [MESSAGE_TYPES.ANNOTATIONS_UPDATED]: handleAnnotationUpdated,
}

export default SlideAnnotationsWebsocketSubscriber
